<template>
  <div class="index-community-card">
    <div class="card-title">{{ $t('propertyIndex.communityInfo') }}</div>
    <el-row :gutter="16" class="stat-items">
      <el-col :span="6" v-for="(item, index) in statItems" :key="index">
        <div class="stat-item" :class="{ 'stat-item-link': item.link }" @click="item.link && item.link()">
          <div class="stat-icon" :style="{ background: item.bgColor }">
            <i :class="item.icon" :style="{ color: item.color }"></i>
          </div>
          <div class="stat-value">
            <template v-if="!item.isLink">
              {{ indexCommunityViewInfo[item.key] }}
              <span v-if="item.unit" class="stat-unit">{{ $t(`propertyIndex.${item.unit}`) }}</span>
            </template>
            <template v-else>
              <i class="el-icon-right" style="font-size:20px;"></i>
            </template>
          </div>
          <div class="stat-label" :class="{ 'link-label': item.link }">
            {{ $t(`propertyIndex.${item.label}`) }}
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getPropertyAssetsIndex } from '@/api/index/propertyIndexApi'

export default {
  name: 'IndexCommunity',
  data() {
    return {
      indexCommunityViewInfo: {
        floorCount: 0,
        roomCount: 0,
        shopCount: 0,
        ownerCount: 0,
        spaceCount: 0,
        carCount: 0,
      },
      statItems: [
        { key: 'floorCount', label: 'building', icon: 'el-icon-office-building', color: '#4B7AF0', bgColor: '#EEF2FF' },
        { key: 'roomCount', label: 'house', icon: 'el-icon-house', color: '#01C36D', bgColor: '#ECFDF5' },
        { key: 'ownerCount', label: 'ownerCount', unit: 'unit', icon: 'el-icon-s-custom', color: '#8B5CF6', bgColor: '#F5F3FF' },
        { key: '_link', label: 'registerResident', icon: 'el-icon-user', color: '#F97316', bgColor: '#FFF7ED', link: this._toOwner, isLink: true }
      ]
    }
  },
  methods: {
    _loadPropertyIndexAssets() {
      const param = {
        page: 1,
        row: 10,
        communityId: this.getCommunityId()
      }
      getPropertyAssetsIndex(param)
        .then(res => {
          if (res.code === 0) {
            Object.assign(this.indexCommunityViewInfo, res.data)
          }
        })
        .catch(err => {
          console.error('请求失败处理', err)
        })
    },
    _toOwner() {
      this.$router.push('/pages/property/listOwner?tab=ownerInfo')
    }
  }
}
</script>

<style lang="scss" scoped>
.index-community-card {
  background: #fff;
  border-radius: 4px;
  padding: 15px;

  .card-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 15px;
  }

  .stat-items {
    .stat-item {
      text-align: center;
      padding: 16px 8px;
      border-radius: 6px;
      background: #FAFBFC;
      transition: box-shadow 0.2s;

      &:hover {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      }

      .stat-icon {
        width: 36px;
        height: 36px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 10px;

        i {
          font-size: 18px;
        }
      }

      .stat-value {
        font-size: 24px;
        font-weight: 700;
        color: #333;
        line-height: 1.2;

        .stat-unit {
          font-size: 12px;
          color: #999;
          font-weight: 400;
        }
      }

      .stat-label {
        font-size: 12px;
        color: #999;
        margin-top: 4px;
      }

      &.stat-item-link {
        cursor: pointer;

        .link-label {
          color: #409EFF;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
}
</style>